// src/lib/i18n.js — SAFE VERSION: no crashes from localStorage
import { createContext, useContext, useState } from 'react'

export const LANGUAGES = [
  { code: 'en', label: 'English',   flag: '🇺🇸' },
  { code: 'es', label: 'Español',   flag: '🇪🇸' },
  { code: 'fr', label: 'Français',  flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch',   flag: '🇩🇪' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
]

const T = {
  en: {
    login:'Login', join:'Join', signOut:'Sign Out',
    welcome:'Welcome,', yourPrivateVault:'Your Private Vault',
    overview:'Overview', message:'Message', voiceCall:'Voice Call',
    dinner:'Dinner', vault:'Vault', contacts:'Contacts', referEarn:'Refer & Earn',
    theAdmirer:'The Admirer', theCompanion:'The Companion', theIntimateCircle:'The Intimate Circle',
    forgotPassword:'Forgot password?', welcomeBack:'Welcome Back',
    signInToAccess:"Sign in to access your Lover's Card",
    emailAddress:'Email Address', password:'Password', enterVault:'Enter the Vault',
    noCard:"Don't have a card yet?", chooseYourTier:'Choose your tier →',
    alreadyMember:'Already a member?', signIn:'Sign in →',
    incorrectCredentials:'Incorrect email or password',
  },
  es: {
    login:'Iniciar sesión', join:'Unirse', signOut:'Cerrar sesión',
    welcome:'Bienvenido,', yourPrivateVault:'Tu Vault Privado',
    overview:'Resumen', message:'Mensaje', voiceCall:'Llamada', dinner:'Cena',
    vault:'Vault', contacts:'Contactos', referEarn:'Referir y Ganar',
    theAdmirer:'El Admirador', theCompanion:'El Compañero', theIntimateCircle:'El Círculo Íntimo',
    forgotPassword:'¿Olvidaste tu contraseña?', welcomeBack:'Bienvenido de Nuevo',
    signInToAccess:'Inicia sesión para acceder a tu tarjeta',
    emailAddress:'Correo Electrónico', password:'Contraseña', enterVault:'Entrar al Vault',
    noCard:'¿No tienes tarjeta?', chooseYourTier:'Elige tu nivel →',
    alreadyMember:'¿Ya eres miembro?', signIn:'Iniciar sesión →',
    incorrectCredentials:'Correo o contraseña incorrectos',
  },
  fr: {
    login:'Connexion', join:'Rejoindre', signOut:'Se déconnecter',
    welcome:'Bienvenue,', yourPrivateVault:'Votre Vault Privé',
    overview:'Aperçu', message:'Message', voiceCall:'Appel', dinner:'Dîner',
    vault:'Vault', contacts:'Contacts', referEarn:'Parrainer et Gagner',
    theAdmirer:"L'Admirateur", theCompanion:'Le Compagnon', theIntimateCircle:'Le Cercle Intime',
    forgotPassword:'Mot de passe oublié?', welcomeBack:'Bienvenue',
    signInToAccess:'Connectez-vous pour accéder à votre carte',
    emailAddress:'Adresse E-mail', password:'Mot de passe', enterVault:'Entrer dans le Vault',
    noCard:'Pas encore de carte?', chooseYourTier:'Choisissez votre niveau →',
    alreadyMember:'Déjà membre?', signIn:'Se connecter →',
    incorrectCredentials:'E-mail ou mot de passe incorrect',
  },
  de: {
    login:'Anmelden', join:'Beitreten', signOut:'Abmelden',
    welcome:'Willkommen,', yourPrivateVault:'Dein Privater Vault',
    overview:'Übersicht', message:'Nachricht', voiceCall:'Anruf', dinner:'Abendessen',
    vault:'Vault', contacts:'Kontakte', referEarn:'Empfehlen und Verdienen',
    theAdmirer:'Der Bewunderer', theCompanion:'Der Begleiter', theIntimateCircle:'Der Intime Kreis',
    forgotPassword:'Passwort vergessen?', welcomeBack:'Willkommen zurück',
    signInToAccess:'Melde dich an um auf deine Karte zuzugreifen',
    emailAddress:'E-Mail-Adresse', password:'Passwort', enterVault:'Den Vault betreten',
    noCard:'Noch keine Karte?', chooseYourTier:'Wähle deine Stufe →',
    alreadyMember:'Bereits Mitglied?', signIn:'Anmelden →',
    incorrectCredentials:'Falsche E-Mail oder falsches Passwort',
  },
  pt: {
    login:'Entrar', join:'Participar', signOut:'Sair',
    welcome:'Bem-vindo,', yourPrivateVault:'Seu Vault Privado',
    overview:'Visão Geral', message:'Mensagem', voiceCall:'Chamada', dinner:'Jantar',
    vault:'Vault', contacts:'Contatos', referEarn:'Indicar e Ganhar',
    theAdmirer:'O Admirador', theCompanion:'O Companheiro', theIntimateCircle:'O Círculo Íntimo',
    forgotPassword:'Esqueceu a senha?', welcomeBack:'Bem-vindo de Volta',
    signInToAccess:'Entre para acessar seu cartão',
    emailAddress:'Endereço de E-mail', password:'Senha', enterVault:'Entrar no Vault',
    noCard:'Ainda não tem cartão?', chooseYourTier:'Escolha seu nível →',
    alreadyMember:'Já é membro?', signIn:'Entrar →',
    incorrectCredentials:'E-mail ou senha incorretos',
  },
}

const LangContext = createContext({ lang:'en', changeLang:()=>{}, t:(k)=>k })

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('skybri-lang') || 'en' }
    catch { return 'en' }
  })

  function changeLang(code) {
    setLang(code)
    try { localStorage.setItem('skybri-lang', code) } catch {}
  }

  const t = (key) => T[lang]?.[key] || T['en']?.[key] || key

  return (
    <LangContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang() {
  return useContext(LangContext)
}
